import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "../Actions/actionTypes";
import * as DateTypes from "../DataTypes/dateTypes";

export const availability = (
    state: DateTypes.Availability,
    action: ActionGenerics.IAction<ActionTypes.Actions>
): DateTypes.Availability => {
    switch (action.type) {
        case ActionTypes.Actions.UpdateAvailability: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, DateTypes.Availability>;

            const newData = data.parameter;

            const availability = { ...state };

            for (let year in newData) {
                const existingYear = availability[year];
                if (!existingYear) {
                    availability[year] = newData[year];
                    continue;
                }

                for (let month in newData[year]) {
                    availability[year][month] = newData[year][month];
                }
            }

            return availability;
        }

        case ActionTypes.Actions.FlushAvailability: {
            return null;
        }

        default:
            return state;
    }
};
